<template>
  <div v-if="logged">
    <TheMobileHeader v-if="$vuetify.breakpoint.smAndDown && logged" />
    <v-container :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'mt-5'">
      <v-row>
        <v-col cols="12" md="4">
          <TheSideBar />
        </v-col>
        <v-col cols="12" md="8">
          <v-row align="center" justify="center">
            <v-col cols="12" lg="8">
              <h2 class="color-purple mb-5 home-title" v-if="journey">
                <span v-if="journey.etapa === 'explorando'">É hora de explorar 😜</span>
                <span v-if="journey.etapa === 'descobrindo'">Vamos descobrir...😁</span>
                <span v-if="journey.etapa === 'experimentando'">Bora Experimentar! 😎</span>
                <span v-if="journey.etapa === 'escolhendo'">Estamos quase lá! 🙌</span>
              </h2>
            </v-col>
            <v-col class="text-right" v-if="!$vuetify.breakpoint.smAndDown">
              <img src="@/assets/share@1,5x.svg" v-if="webShareApiSupported" class="fakeLink" @click="shareViaWebShare()" />
            </v-col>
          </v-row>

          <div v-if="posts">
            <ThePostCard v-for="(item, i) in posts" :key="i" :post="item" />
          </div>

          <TheInfoJourney />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl } from '@/global'

import TheSideBar from '@/components/TheSideBar'
import TheMobileHeader from '@/components/TheMobileHeader'
import TheInfoJourney from '@/components/TheInfoJourney'
import ThePostCard from '@/components/ThePostCard'
import { mapState } from 'vuex'

export default {
  components: {
    TheSideBar,
    ThePostCard,
    TheMobileHeader,
    TheInfoJourney,
  },
  computed: {
    ...mapState(['logged', 'sequence', 'popup', 'journey', 'sequence']),
    webShareApiSupported() {
      return navigator.share
    },
  },
  data: () => ({
    posts: [],
  }),
  watch: {
    sequence() {
      if (this.sequence === false) {
        this.loadContent()
      }
    },
  },
  methods: {
    loadContent() {
      const url = `${baseApiUrl}/list`
      axios
        .get(url)
        .then((res) => {
          this.posts = res.data
        })
        .catch((err) => {
          if (!err.response.status === 403) {
            this.$store.dispatch('setErrorInfo', {
              open: true,
              text: 'Ops! Parece que algo deu errado. :( Talvez tenha sido um erro no link, ou alguma instabilidade no site (se for isso, já estamos resolvendo). ;) ',
            })
          }
        })
    },
    shareViaWebShare() {
      // navigator.share({
      //   title: 'Conecta Meu Futuro',
      //   text: 'Uma plataforma que vai te conectar ou reconectar com a sua jornada universitária. Embarca nessa jornada com a gente.',
      //   url: 'https://conectaunisinos.paimlab.com.br/',
      // })
      window.open(
        'https://wa.me/?text=%2aConecta%20Meu%20Futuro%2e%2a%20Uma%20plataforma%20que%20vai%20te%20conectar%20ou%20reconectar%20com%20a%20sua%20jornada%20universitária%2E%20Embarca%20nessa%20jornada%20com%20a%20gente%3A%20unisinos%2Ebr%2fconectameufuturo',
        '_BLANK'
      )
    },
  },
  mounted() {
    this.$store.dispatch('setMobileRouterInfo', '/')
    localStorage.removeItem('salveProfile')
    this.loadContent()

    // Tutorial
    this.$store.dispatch('setTutorialInfo', {
      open: true,
      step: 2,
    })
  },
  created() {
    window.scrollTo(0, 0)
  },
}
</script>

<style>
.home-title {
  color: #502d7c;
  font-size: 23px;
  letter-spacing: 0;
  line-height: 31px;
}
.emoji {
  font-family: 'Apple Color Emoji' !important;
}
</style>
